import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { path } from 'ramda';
import TeamCreator from './TeamCreator';
import TeamTable from './TeamsTable';
import TeamEditor from './TeamEditor';

const TeamsManager = ({
  match,
  role,
}) => (
  <Switch>
    <Route path={`${match.url}/`} exact component={TeamTable} />
    <Route path={`${match.url}/new`} exact component={TeamCreator} />
    <Route
      path={`${match.url}/:id`}
      exact
      render={props => (
        <TeamEditor
          teamId={path(['match', 'params', 'id'], props)}
          role={role}
          {...props}
        />
      )}
    />
  </Switch>
);

TeamsManager.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export const TeamManager = TeamEditor;

export default TeamsManager;
